module.exports = __webpack_public_path__ + "media/assets/svg/screens/omnichannel_inbox_hexagon-578d2843afbda43a302d1cafbf7f91c1.svg";